import script from "./ProjectLogFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectLogFilters.vue?vue&type=script&setup=true&lang=js"

import "./ProjectLogFilters.vue?vue&type=style&index=0&id=63af2651&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63af2651"]])

export default __exports__